<template>
  <update-username />
</template>

<script>
import UpdateUsername from '@/components/Profile/UpdateUsername'

export default {
  components: {
    UpdateUsername,
  },
}
</script>
